import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import limparUltimosHistoricosPassageiro from '../../actions/pedido/limparUltimosHistoricosPassageiro';

import Moment from 'react-moment';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';

export const Cabecalho = () => (
    <div className="lista-eventos titulo">
      <div className="row cabecalho-desktop" style={{ fontWeight: 'bold'}}>
        <div className="col-12 col-sm-12 col-md">Data e Hora</div>
        <div className="col-12 col-sm-12 col-md">Situação</div>
        <div className="col-12 col-sm-12 col-md">Usuário</div>
        <div className="col-12 col-sm-12 col-md">CPF</div>
        <div className="col-12 col-sm-12 col-md">Nome</div>
        <div className="col-12 col-sm-12 col-md">Data Nascimento</div>
        <div className="col-12 col-sm-12 col-md">N&deg;. Documento Com Foto</div>        
        <div className="col-12 col-sm-12 col-md">Telefone</div>        
      </div>
    </div>
  );

export class ModalHistoricoPassageiro extends Component {

    fecharModal () {
        $('#modalHistoricoPassageiro')
            .modal('hide');
        $('#modalHistoricoPassageiro')
            .hide();
        $('.modal-backdrop')
            .hide();        
        this.props.limparUltimosHistoricosPassageiro();        
    }

    exibirHistoricos() {
        if (this.props.historicos && this.props.historicos.length) {
            return this.props.historicos.map(historico => <>
            <h2>Reserva {historico.reservaId}</h2>
            <Cabecalho />
            <div className="lista-eventos" key={`${historico.reservaId}`}>                
                {historico.historicosPassageiro.map(historicoPass => <div className="row conteudo-desktop" key={`${historicoPass.id}`}>
                    <div className="col-12 col-sm-12 col-md">
                        <Moment
                            format="DD/MM/YYYY HH:mm">{historicoPass.dataEvento}</Moment>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{capitalizarTodasPrimeirasLetras(historicoPass.tipoEvento)}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{capitalizarTodasPrimeirasLetras(historicoPass.responsavel.nome)}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historicoPass.passageiro.cpf}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{capitalizarTodasPrimeirasLetras(historicoPass.passageiro.nome)}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historicoPass.passageiro.dtNascimento ? historicoPass.passageiro.dtNascimento : ''}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historicoPass.passageiro.documentoComFoto ? historicoPass.passageiro.documentoComFoto : ''}</p>
                        </div>
                    </div>                        
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historicoPass.passageiro.ddi ? historicoPass.passageiro.ddi : ''} {historicoPass.passageiro.telefone ? historicoPass.passageiro.telefone : ''}</p>
                        </div>
                    </div>
                </div>)}
                    
                {historico.historicosCrianca && <h4>Histórico Criança </h4>}
                {historico.historicosCrianca && historico.historicosCrianca.map(historicosCri => <div className="row conteudo-desktop" key={`${historicosCri.id}`}>
                        <div className="col-12 col-sm-12 col-md">
                            <Moment
                                format="DD/MM/YYYY HH:mm">{historicosCri.dataEvento}</Moment>
                        </div>
                        <div className="col-12 col-sm-12 col-md">
                            <div id="evento" className="texto">
                                <p>{capitalizarTodasPrimeirasLetras(historicosCri.tipoEvento)}</p>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md">
                            <div id="usuario" className="texto">
                                <p>{capitalizarTodasPrimeirasLetras(historicosCri.responsavel.nome)}</p>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md">
                            <div id="usuario" className="texto">
                                <p>{historicosCri.crianca.cpfCrianca}</p>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md">
                            <div id="usuario" className="texto">
                                <p>{capitalizarTodasPrimeirasLetras(historicosCri.crianca.nome)}</p>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md">
                            <div id="usuario" className="texto">
                                <p>{historicosCri.crianca.dtNascimentoCrianca ? historicosCri.crianca.dtNascimentoCrianca : ''}</p>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md">
                            <div id="usuario" className="texto">
                                <p>{historicosCri.crianca.documentoCriacaComFoto ? historicosCri.crianca.documentoCriacaComFoto : ''}</p>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md">
                            <div id="usuario" className="texto">                                
                            </div>
                        </div>
                    </div>)}
            </div>
            </>)
        }
        return ''
    }

    render() {
        return (
            <div className="modal fade show" id='modalHistoricoPassageiro' role='dialog'
            aria-labelledby='modalHistoricoPassageiro' aria-hidden='true' data-backdrop='static'>
            <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                <div className="modal-content">
                    <div className="modal-header">                        
                        <h5>Históricos Passageiros Pedido {this.props.historicos && this.props.historicos.length ? this.props.historicos[0].pedidoId : ''}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <i className="material-icons" onClick={() => this.fecharModal()}>
                                &#xe5cd;
                            </i>
                        </button>
                    </div>
                    <div className="modal-body">                        
                        {this.exibirHistoricos()}
                    </div>
                </div>
            </div>
        </div>
        )
    }
}

export const mapStateToProps = (state) => {
    return {        
        empresaSelecionada: state.empresaSelecionada,        
        historicos: state.ultimosHistoricosPassageiro,
        pedido: state.pedido
    }
};

export default connect(mapStateToProps, {    
    limparUltimosHistoricosPassageiro
})(ModalHistoricoPassageiro)